import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * The content column of a page: one width rhythm and gutter for every screen. The outer element
 * is the screen's only scroll area inside the shell's viewport frame.
 */
export function Page(props: {
  children: ReactNode;
  width?: "narrow" | "default" | "wide";
  className?: string;
}) {
  const width =
    props.width === "narrow" ? "max-w-3xl" : props.width === "wide" ? "max-w-7xl" : "max-w-5xl";
  return (
    <div data-scroll-owner="page" className="min-h-0 flex-1 overflow-y-auto">
      <div
        className={cn(
          "mx-auto flex min-h-full w-full flex-col gap-8 px-4 py-6 sm:px-6 md:px-10 md:py-10",
          width,
          props.className,
        )}
      >
        {props.children}
      </div>
    </div>
  );
}
